import axios from "axios";
import { IMetaDataResponse } from "./store";
import { API_URL } from "@/config";

const API = `${API_URL}/invoice`;

export interface IInvoice {
    id: string;
    amount_due: number;
    amount_remaining: number;
    metadata: IMetaDataResponse;
    lines: {
        data: IInvoiceItem[];
    };
    status: string;
}
export interface IInvoiceItem {
    id: string;
    amount: number;
    description: string;
    metadata: IMetaDataResponse;
}

export const getInvoiceById = async (invoice_id: string) => {
    const result: { data: IInvoice } = await axios.get(`${API}/${invoice_id}`, {
        headers: {
            "Cache-Control": "no-cache, no-store, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
        },
    });
    return result.data;
};

export const deleteInvoiceItem = async (item_id: string) => {
    const result: { data: IInvoiceItem } = await axios.delete(
        `${API}/items/${item_id}`,
        {
            headers: {
                "Cache-Control": "no-cache, no-store, must-revalidate",
                Pragma: "no-cache",
                Expires: "0",
            },
        }
    );
    return result.data;
};
